import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import ErrorMessage from '../../components/forms/fields/errorMessage';

export const MultipleSelect = ({
  field,
  form: { setFieldValue, touched, errors },
  otherProps
}) => {
  const { creatable = false, ...restOtherProps } = otherProps;

  const SelectComponent = creatable ? Select.Creatable : Select;

  const hasError = !!(touched[field.name] && errors[field.name]);

  const arrowRenderer = () => (
    <Icon name='angle down' />
  );

  return (
    <Container>
      <SelectComponent
        className='styledSelect'
        multi
        value={field.value}
        menuPlacement='top'
        isValidNewOption={({ label }) => {
            if (!label) return false;
            return label.length > 1 || !(/[^a-z0-9]+/g.test(label));
        }}
        onChange={selectedOptions => {
            setFieldValue(field.name, selectedOptions);
        }}
        onBlur={field.onBlur}
        {...restOtherProps}
        error={touched[field.name] && errors[field.name]}
        arrowRenderer={arrowRenderer}
      />
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Container>
  );
};

const Container = styled.div`
    width: 100%;
    border-radius: 8px;
    min-height: 44px;
    width: 100%;

    .styledSelect div.Select-control {
        border-radius: 8px;
        min-height: 44px;
        width: 100%;
        font-family: 'Quicksand' !important;
        font-style: 'normal';
        font-weight: '600';
        font-size: 16px;
        line-height: 44px !important;
        border: 1px solid #99B2C6 !important;
        box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05); 
    }

    .styledSelect.is-focused .Select-control {
        border: 1px solid #0094FB !important;
        box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05) !important; 
    }
    .styledSelect.is-open .Select-control {
        border: 1px solid #0094FB !important;
    }

    .styledSelect div.Select-placeholder {
        color: #809FB8;
        line-height: 44px !important;
        font-weight: 600;
    }    

    .styledSelect div.Select-multi-value-wrapper {
        line-height: 44px;
    }

    .styledSelect div.Select-input {
        line-height: 44px;
    }

    .styledSelect.Select--multi .Select-value  {
        background-color: #CCEAFE;
        border-radius: 6px;
        font-family: 'Quicksand';
        font-style: 'normal',
        font-weight: '500',
        font-size: '16px',
        line-height: '20px',
        color: '#667085',
        display: inline-flex !important;
        flex-direction: row-reverse;
        justify-content:center;
        vertical-align:middle !important;
        margin: 0 2px;
    }
    .Select--multi .Select-value {
        vertical-align:middle !important;
        display: inline-flex !important;
    }

    .styledSelect.Select--multi .Select-value-label {
        color: #101828;
        margin-top: 0 !important;
    }
    .styledSelect.Select--multi .Select-value-icon {
        color: #0094FB;
    }

    .Select-input {
        height: 44px !important;
    }
`;



// WEBPACK FOOTER //
// ./src/uiStandard/event/multipleSelect.js